// This component is deprecated
import React from 'react'
import PlaceholderImage from 'components/PlaceholderImage'
const ResultImage = ({ result }) => {
  let theImageID = result.image.id || result.imageId

  return (
    <>
      <PlaceholderImage
        src={`${process.env.SITE_ASSET_URL}/${theImageID}`}
        alt=""
        width={745}
        height={408}
      />
    </>
  )
}
export default ResultImage
